;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');

	Router.Help = Marionette.AppRouter.extend({
		appRoutes: {
			'(off-season/)help/prizes': 'prizes',
			'(off-season/)help/terms': 'terms',
			'(off-season/)help/faqs': 'faqs',
			'(off-season/)help/game-rules': 'rules',
			'(off-season/)help/game-guidelines': 'guidelines',
			'(off-season/)help': 'terms'
		}

	});

}(window, APP, Backbone, Marionette, $, _));